import { PermissionSetting } from './PermissionSetting';
export default PermissionSetting;
